import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';
import { Save } from 'lucide-react';

export const TopNavManager = () => {
  const { getAuthHeader } = useAuth();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState({
    shop_now_url: '',
  });

  const API_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    fetchTopNav();
  }, []);

  const fetchTopNav = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/topnav`);
      setFormData(response.data);
    } catch (error) {
      console.error('Error fetching top nav:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await axios.put(`${API_URL}/api/topnav`, formData, {
        headers: getAuthHeader(),
      });
      alert('Top navigation updated successfully!');
    } catch (error) {
      console.error('Error updating top nav:', error);
      alert('Failed to update top navigation');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="text-white">Loading...</div>;
  }

  return (
    <div className="max-w-4xl">
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="bg-gray-800 border border-gray-700 rounded-lg p-6">
          <h3 className="text-xl font-bold text-white mb-4">Top Navigation Settings</h3>

          <div className="space-y-4">
            <div>
              <label className="block text-white text-sm font-medium mb-2">
                "Shop Now" Button URL (Top Right Corner)
              </label>
              <input
                type="url"
                value={formData.shop_now_url}
                onChange={(e) =>
                  setFormData({ ...formData, shop_now_url: e.target.value })
                }
                className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white focus:outline-none focus:ring-2 focus:ring-orange-500"
                placeholder="https://amazon.com/your-product"
              />
              <p className="text-gray-400 text-xs mt-2">
                This is the URL for the orange "SHOP NOW" button in the top navigation bar
              </p>
            </div>
          </div>
        </div>

        <button
          type="submit"
          disabled={saving}
          className="flex items-center px-6 py-3 bg-orange-600 text-white rounded-lg hover:bg-orange-700 disabled:opacity-50"
        >
          <Save className="w-5 h-5 mr-2" />
          {saving ? 'Saving...' : 'Save Changes'}
        </button>
      </form>
    </div>
  );
};
